{
  "main":{
    "title":"Административная панель",
    "home" :"Главная"
  },
  "auth": {
    "agree": "Принять",
    "createAccount": "Создать пользователя",
    "createNewAccount": "Создать нового пользователя",
    "email": "Почта",
    "login": "Логин",
    "password": "Пароль",
    "recover_password": "Восстановить пароль",
    "sign_up": "Регистрация",
    "keep_logged_in": "Оставаться на сайте",
    "termsOfUse": "Условия использования",
    "reset_password": "Сбросить пароль"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "language":"Язык",
    "russian":"Русский",
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Авторизация",
    "buttons": "Кнопки",
    "timelines": "Timelines",
    "dashboard": "Мониторинг",
    "billing": "Счета",
    "login": "Вход",
    "preferences": "Профиль",
    "payments": "Оплата",
    "settings": "Настройки",
    "pricing-plans": "Тарифы",
    "payment-methods": "Способы оплаты",
    "signup": "Регистрация",
    "recover-password": "Восстановление пароля",
    "recover-password-email": "Восстановление пароля по почте",
    "404": "404",
    "faq": "ЧаВо",
    "users": "Пользователи",
    "companies": "Компании",
    "firmwares": "Прошивки",
    "kkt":"Кассы",
    "license":"Лицензии"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Язык",
    "logout": "Выход",
    "profile": "Профиль",
    "settings": "Настройки",
    "billing": "Оплата",
    "faq": "ЧаВо",
    "helpAndSupport": "Поддержка",
    "projects": "Проекты",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Поддержка и консультация",
  "search": {
    "placeholder": "Поиск..."
  },
  "buttonSelect": {
    "dark": "Темная",
    "light": "Светлая"
  },
  "login":{
    "loginTitle":"Авторизация",
    "login":"Вход"
  },
  "users":{
    "title":"Пользователи",
    "active":"Активные",
    "inactive":"Заблокированные",
    "add":"Добавить",
    "adduser":"Добавить пользователя",
    "edit":"Редактировать",
    "edituser":"Редактировать пользователя",
    "fullName":"ФИО",
    "email":"Почта",
    "login":"Логин",
    "role":"Роль",
    "phone":"Телефон",
    "actions":"Действие",
    "addavatar":"Загрузить аватар",
    "password" :"Пароль",
    "save":"Сохранить",
    "cancel":"Отмена"
  },
  "companies":{
    "title":"Компании",
    "fullName":"Полное наименование",
    "shortName":"Краткое наименование",
    "version_105":"Версия ФФД 1.05",
    "date_105":"Срок действия ФФД 1.05",
    "kkt_105":"ККТ ФФД 1.05",
    "version_120":"Версия ФФД 1.2",
    "date_120":"Срок действия ФФД 1.2",
    "kkt_120":"ККТ ФФД 1.2",
    "all_kkt":"Всего ККТ",
    "add":"Добавить",
    "edit":"Редактировать",
    "delCompany":"Удаление компании"
  },
  "kkt":{
    "title":"Кассы",
    "number":"Номер",
    "ffd":"ФФД",
    "company":"Компания",
    "license":"Лицензия",
    "version":"Версия",
    "delKкt":"Удаление кассы"
  },
  "firmwares":{
    "title":"Прошивки",
    "name":"Наименование",
    "date":"Дата",
    "ffd":"ФФД",
    "version":"Версия"
  },
  "licenses":{
    "title":"Лицензии",
    "company":"Компания",
    "kkt_min":"Мин. номер кассы",
    "kkt_max":"Макс. номер кассы",
    "date":"Дата",
    "date_to":"Дата действия лицензии",
    "ffd":"ФФД",
    "ffd_type":"Tип прошивки",
    "version":"Версия",
    "version_number":"Номер версии прошивки",
    "firmware":"Прошивка",
    "data":"Данные",
    "delLic":"Удаление лицензии",
    "update":"Обновить",
    "updateVer":"Обновить версии",
    "created" :"Лицензия добавлена",
    "bugfix":"Bugfix"
  },
  "settings":{
    "title":"Настройки",
    "theme":"Цветовая тема"
  },
  "vuestic": {
    "search": "Поиск",
    "noOptions": "Данные не найдены",
    "ok": "OK",
    "cancel": "Отмена",
    "uploadFile": "Загрузить файл",
    "undo": "Назад",
    "dropzone": "Переместить файл для загрузки",
    "fileDeleted": "Файл удален",
    "closeAlert": "закрыть",
    "backToTop": "в начало",
    "toggleDropdown": "открыть список",
    "carousel": "карусель",
    "goPreviousSlide": "предыдущий слайд",
    "goNextSlide": "следующий слайд",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "закрыть",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "цвет {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option",
    "undoButtonText":"Отмена"
  },
  "messages":{
    "loginSuccess":"Добро пожаловать!",
    "loginFail":"Ошибка авторизации",
    "warnDelete":"Вы действительно хотите удалить",
    "delete":"Удалить",
    "cancel":"Отмена",
    "save":"Сохранить",
    "results":"результатов",
    "resultsPerPage":"Результатов на страницу",
    "deleted": "удалено",
    "created": "создано",
    "updated": "изменено",
    "loaded":"загружен",
    "fileloaded":"Файл загружен",
    "Error": "Ошибка!",
    "addition":"Добавление",
    "add":"Добавить",
    "edition":"Редактирование",
    "unsaveWarn":"Данные не сохранены. Вы действительно хотите отменить?",
    "nodata":"Нет данных",
    "actions":"Действия",
    "show":"Показать",
    "addfile":"Загрузить файл",
    "selectfile":"Выбрать файл"
  }
}
